import { useReducer, useCallback } from 'react';

const ACTIONS = {
  SET_ENTITY_TYPES: 'SET_ENTITY_TYPES',
  SELECTION_CHANGE: 'SELECTION_CHANGE',
  RESET_SELECTION: 'RESET_SELECTION'
};

const dataReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SELECTION_CHANGE:
      return action.payload.checked
        ? [...state, action.payload.entity]
        : state.filter(e => e.id !== action.payload.entity.id);
    case ACTIONS.RESET_SELECTION:
      return [];
    default:
      throw new Error();
  }
};

export default () => {
  const [selectedEntities, dispatch] = useReducer(dataReducer, []);

  const onSelectionChange = useCallback(({ entity, checked }) => {
    dispatch({
      type: ACTIONS.SELECTION_CHANGE,
      payload: {
        entity,
        checked
      }
    });
  }, []);

  const clearSelection = useCallback(() => {
    dispatch({ type: ACTIONS.RESET_SELECTION });
  }, []);

  return { selectedEntities, onSelectionChange, clearSelection };
};
